
import {Component, Vue, Prop} from "vue-property-decorator";
import {namespace} from "vuex-class";
import comptageService from '@/services/comptage.service';
import enrichissementService from '@/services/enrichissement.service';
import qualiteService from "@/services/qualite.service";
import http from "@/services/api.service";
import basketService from "@/services/panier.service"
import frontService from "@/services/front.service";

const userModule = namespace("userModule");
const panierModule = namespace("panierModule");

@Component({
    components: {}
})
export default class SidebarPanier extends Vue {

    @Prop() readonly result!: { nb: number; credits: number };
    @Prop() panier;

    @userModule.State
    public user!: any;

    @userModule.Action
    public getUser;

    @userModule.Mutation
    public setCredits;

    @panierModule.Action
    public setCountField!: (count: number) => void;

    interval = 0;

    dialogValidationOrder = false;
    loading = false;
    isOrdering = false;


    getKeyFromType(type: string): number {
        switch (type) {
            case 'Comptage':
                return 34;
            case 'Enrichissement':
                return 35;
            case 'Mise en qualité':
                return 36;
            default:
                return null;
        }
    }

    order() {
        this.loading = true;
        this.isOrdering = true;
        setTimeout(() => {
            this.spendCredit(this.panier.products.map((p) => {
                return {moduleId: this.getKeyFromType(p.type), credits: p.credit};
            }));
            localStorage.setItem('order', JSON.stringify(this.panier.products.map(p => p.id)));
            localStorage.setItem('orderTime', Date.now().toString());
            this.setCountField(0);
            this.loading = false;
            this.isOrdering = false;
            this.dialogValidationOrder = true;
            this.$emit('order', null);
        }, 2000);
        this.dialogValidationOrder = false;
        basketService.dealWithMultipleBasket(this.panier.products, this.user);
        for (const product of this.panier.products) {
            if (product.type == 'Comptage') {
                comptageService.order(product.filters, product, this.user);
            } else if (product.type == 'Enrichissement') {
                enrichissementService.order(product.filters, this.user, product);
            } else if (product.type == 'Mise en qualité') {
                qualiteService.order(product.filters, this.user, product);
            }
        }
    }

    get total() {
        return this.panier.products.reduce(
            (accumulator, currentValue) => Number(accumulator) + Number(currentValue.credit),
            0
        );
    }

    spendCredit(spendCreditMap) {
        const token = localStorage.getItem('tokenJWT');
        const formData = new FormData();
        let i = 0;
        for (const pair of spendCreditMap) {
            formData.append("usages[" + i + "][module]", pair.moduleId.toString());
            formData.append("usages[" + i + "][credit]", pair.credits.toString());
            i++;
        }
        const url = process.env.VUE_APP_CREDIT_URI;
        return http.post(url + "/usages", formData, {
            headers: {'Authorization': "Bearer " + token, 'Content-Type': 'application/json'}
        }).then(
            result => {
                if (result && result.data) {
                    this.getUser().then(res => {
                        if (!res) {
                            this.$router.go(0);
                        }
                    });
                }
            },
            error => {
                if (error.response && error.response.status === 401 && error.response.data && error.response.data.message && error.response.data.message === "Expired JWT Token") {
                    let total = 0;
                    for (const pair of spendCreditMap) {
                        total += pair.credits;
                    }
                    this.setCredits(this.user.credits - total);
                    localStorage.removeItem('tokenJWT');
                    localStorage.removeItem('expiration');
                    localStorage.removeItem('refreshToken');
                    localStorage.removeItem('scope');
                    localStorage.removeItem('tokenType');
                    this.$router.push('login');
                }
            });
    }

    formatNumber(x) {
        return frontService.numberWithSpaces(x);
    }
}
